<template>
    <LoadingContent v-if="isLoadingTime && !errorDate"/>
    <div class="time-list-carousel">
        <div v-if="Object.keys(timeList).length" class="time-form-content">
            <div v-for="(group, group_key) in timeList" :key="group_key">
                <h6 v-if="group && group[0]?.group" class="time-form-title">{{ group[0].group.name }}</h6>
                <div class="time-form-item unselectable">
                    <label v-for="(item, key) in group" :key="key">
                        <input type="radio" hidden 
                        v-model="selectTime" 
                        :value="item" 
                        :disabled="!item.available"
                        :checked="group_key === defaultTimeKey && key === 0"
                    />
                        <span>{{ item.timeStart }}</span>
                    </label>
                </div>
            </div>
        </div>
        <div v-else-if="errorDate">
            <div class="my-3 text-center">
                <ul class="formkit-messages mb-3">
                    <li class="formkit-message" style="font-size: 1rem !important;">{{ errorDate }}</li>
                </ul>
                <FormKit
                    v-if="type === 'step'"
                    type="button"
                    data-next="true"
                    @click="prevStep"
                    outer-class="form-kit-btn form-kit-btn__outline__red d-flex justify-content-center"
                >
                    Вернуться к выбору офиса
                </FormKit>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { getNode } from '@formkit/core';

import LoadingContent from '@/components/LoadingContent.vue';

export default {
    name: 'CalendarTimeList',
    props: ['time', 'date', 'branch', 'type'],
    components: {
        LoadingContent
    },
    watch: {
        selectTime(newSelectTime) {
            this.$emit('update:time', newSelectTime);
        },
        branch() {
            this.getTimes();
        },
        date() {
            this.getTimes();
        }
    },
    data: () => {
        return {
            selectTime: '',
            defaultTimeKey: -1,
            timeList: [],
            errorDate: '',
            isLoadingTime: false
        }
    },
    methods: {
        ...mapActions(['fetchTimeSlots']),
        prevStep() {
            const node = getNode('self-record-form');
            node.previous();
        },
        async getTimes () {
            if (!this.branch || !this.date) return;

            this.isLoadingTime = true;
            this.selectTime = '';
            this.errorDate = '';
            this.timeList = [];

            try {
                await this.fetchTimeSlots({
                    date: this.date,
                    office_id: this.branch?.value ? this.branch.value.office_id : this.branch.office_id
                }).then((response) => {
                    if (Object.keys(response.data).length) {
                        this.timeList = response.data;
                        this.defaultTimeKey = Object.entries(response.data).reduce((a, [k, v]) => a[Object.keys(a)[0]] < v ? a : k, {});
                        this.selectTime = this.defaultTimeKey > 0 ? response.data[this.defaultTimeKey][0] : null;
                    } else {
                        this.errorDate = `На выбранную дату нет свободного времени, выберите другой офис или дату`;
                    }
                })
            } catch (e) {
                this.errorDate = `Ошибка в получении свободного времени, повторите попытку`;
            } finally {
                this.isLoadingTime = false;
            }
        }
    },
    async mounted() {
        await this.getTimes();
    }
}
</script>

<style lang="scss" scoped>
.time-list-carousel {
    .time-form-content {
        display: block;
        margin-top: 25px;

        h6 {
            font-family: 'Manrope Regular', serif;
            font-size: 15px;
        }
    
        > :not([hidden]) ~ :not([hidden]) {
            margin-top: 20px;
        }
    
        .time-form-title {
            margin-top: 20px
        }
        .time-form-title:first-child {
            margin-top: 0;
        }
    
        .time-form-item {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(70px, 1fr));
            
            gap: 0.725rem;
            align-items: center;
    
            label {
                text-align: center;
            }
    
            input + span {
                background: #fff;
                border: 1px solid rgb(225, 226, 226);
                border-radius: 12px;
                padding: 14px 17px;
                display: block;
                cursor: pointer;
            }
        
            input:checked + span {
                background: #DF413A;
                color: #fff;
            }
        
            input:disabled + span {
                opacity: .6;
            }

            @media (max-width: 768px) {
                row-gap: 0.5rem;
                column-gap: 0.6rem;
            }
        }
    }
}
</style>